<template>
  <div class='account'>
    <el-menu :default-active="activeName" mode="horizontal" @select="tabChange">
      <el-menu-item index="1">个人资料</el-menu-item>
      <el-menu-item index="2">名片资料</el-menu-item>
      <el-menu-item index="3">账户安全</el-menu-item>
      <el-menu-item index="4">修改密码</el-menu-item>
    </el-menu>
    <First v-if="activeName == '1'"/>
    <Second v-if="activeName == '2'"/>
    <Third v-if="activeName == '3'"/>
    <ChangePsw v-if="activeName == '4'"/>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import First from './child/First';
import Second from './child/Second';
import Third from './child/Third';
import ChangePsw from './child/ChangePsw';

export default {
  data() {
    return {
      defaultTab: '1',
      activeName: '1',
    };
  },
  methods: {
    ...mapMutations(['change_userTab']),
    tabChange(key) {
      this.activeName = key+'';
    },
  },
  computed: {
    ...mapGetters(['userTab']),
  },
  components: {
    First, Second, Third, ChangePsw
  },
  created() {
  },
  mounted () {
    this.activeName = '1';
  }
};


</script>

<style lang="scss" scoped>
.account{
  background: #fff;
  padding-left: 30px;
}
</style>




// WEBPACK FOOTER //
// src/pages/navigator/personal/components/info/Account.vue